<template>
    <v-snackbar
        v-model="show"
        bottom
        :timeout="timeout"
        :color="type"
    >
        {{ message }}
        <v-btn
        color="white"
        text
        @click="show = false"
        >
        Close
        </v-btn>
    </v-snackbar>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      message: '',
      type: '',
      timeout: 6000
    }
  },
  created: function () {
    this.$store.watch(state => state.snackbar.snack, () => {
        const msg = this.$store.state.snackbar.snack
        if (msg !== '') {
            this.show = true
            this.message = this.$store.state.snackbar.snack
            this.type = this.$store.state.snackbar.snacktype
            this.$store.commit('SET_SNACKTYPE', '')
            this.$store.commit('SET_SNACK', '')
        }
    })
  }
}
</script>